/* import __COLOCATED_TEMPLATE__ from './respond-faster.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();